module.exports = __webpack_public_path__ + "img/foto-estagio-1.995e2a08.png";